export const orderStatusLabel = Object.freeze({
  DELIVERED: 'Entregue',
  POC_ACCEPTED: 'Aceito',
  USER_CANCELLED: 'Cancelado pelo usuário',
  POC_REJECT: 'Rejeitado',
  POC_PICKED_UP: 'Retirado',
  SUSPECT: 'Desconsiderado',
  DM_ACCEPTED: 'Entregador Aceitou',
  DM_PICKED_UP: 'Entregador Retirou',
  DM_EN_ROUTE: 'Entregador a caminho',
  DM_CANCELLATION_REQUEST: 'Cancelado pelo Entregador',
  POC_ABANDONED: 'Cancelado pelo PDV',
  POC_EXPIRED: 'Expirado',
  PENDING: 'Pedido colocado',
  TRANSFERED: 'Transferido',
  POC_SCHEDULED: 'Programado',
  CS_CANCELLEDOC: 'Cancelado',
  DM_REJECT: 'Rejeitado',
})

export default Object.freeze({
  PENDING: 'PENDING',
  TRANSFERED: 'TRANSFERED',
  POC_REJECT: 'POC_REJECT',
  POC_ACCEPTED: 'POC_ACCEPTED',
  POC_SCHEDULED: 'POC_SCHEDULED',
  POC_EXPIRED: 'POC_EXPIRED',
  POC_PICKED_UP: 'POC_PICKED_UP',
  USER_CANCELLED: 'USER_CANCELLED',
  CS_CANCELLEDOC: 'CS_CANCELLEDOC',
  DM_REJECT: 'DM_REJECT',
  DM_ACCEPTED: 'DM_ACCEPTED',
  DM_PICKED_UP: 'DM_PICKED_UP',
  DM_EXPIRED: 'DM_EXPIRED',
  DM_EN_ROUTE: 'DM_EN_ROUTE',
  DM_CANCELLATION_REQUEST: 'DM_CANCELLATION_REQUEST',
  DELIVERED: 'DELIVERED',
  SUSPECT: 'SUSPECT',
  POC_ABANDONED: 'POC_ABANDONED',
})

export enum OrderStatus {
  PENDING = 'PENDING',
  TRANSFERED = 'TRANSFERED',
  POC_REJECT = 'POC_REJECT',
  POC_ACCEPTED = 'POC_ACCEPTED',
  POC_SCHEDULED = 'POC_SCHEDULED',
  POC_EXPIRED = 'POC_EXPIRED',
  POC_PICKED_UP = 'POC_PICKED_UP',
  USER_CANCELLED = 'USER_CANCELLED',
  CS_CANCELLEDOC = 'CS_CANCELLEDOC',
  DM_REJECT = 'DM_REJECT',
  DM_ACCEPTED = 'DM_ACCEPTED',
  DM_PICKED_UP = 'DM_PICKED_UP',
  DM_EXPIRED = 'DM_EXPIRED',
  DM_EN_ROUTE = 'DM_EN_ROUTE',
  DM_CANCELLATION_REQUEST = 'DM_CANCELLATION_REQUEST',
  DELIVERED = 'DELIVERED',
  SUSPECT = 'SUSPECT',
  POC_ABANDONED = 'POC_ABANDONED',
}

export enum TimelineOrderStatus {
  REGISTERED = 'REGISTERED',
  VALIDATED = 'VALIDATED',
  ONBOARDING = 'ONBOARDING',
  ASSISTED_OPERATIONAL = 'ASSISTED_OPERATIONAL',
  NOT_VALIDATED = 'NOT_VALIDATED',
  REJECTED = 'REJECTED',
}

export enum OrderExtraStatus {
  WAITING_COURIER = 'WAITING_COURIER',
  WAITING_CONSUMER = 'WAITING_CONSUMER',
}

export enum VariantTypes {
  ERROR = 'error',
  INFO = 'info',
  PROGRESS = 'progress',
  SNACKBAR = 'snackbar',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export enum NanodropOrderStatus {
  PENDING = 'CREATED',
  POC_ACCEPTED = 'ACCEPTED_BY_SELLER',
  POC_REJECT = 'POC_REJECT',
  POC_PICKED_UP = 'POC_PICKED_UP',
  POC_EXPIRED = 'POC_EXPIRED',
  POC_ABANDONED = 'POC_ABANDONED',
  DM_ACCEPTED = 'DM_ACCEPTED',
  DM_PICKED_UP = 'DM_PICKED_UP',
  DM_EN_ROUTE = 'IN_TRANSIT',
}
